export default __webpack_public_path__ + "universal/images/collaboratory.1a38621c0c5b261c00b3d962a6b7e9b6.svg";